import { useEffect, useState } from "react";
import axios from "../lib/axios";
import { ssoDone } from "../lib/sso";

const ADMIN_CHECK_TIMEOUT_MS = 6000;      // 서버 check 는 포털을 부르지 않지만, 느린 망에서 로그아웃처럼 보이지 않게(결정 5)
const EMPTY = { loggedIn: false, role: null, username: null, displayName: null, home: null, portalUrl: null, ssoStart: null };

export default function useAdminAuth() {
  const [state, setState] = useState({ loading: true, ...EMPTY });

  useEffect(() => {
    let alive = true;
    axios.get("/admin/check", { timeout: ADMIN_CHECK_TIMEOUT_MS })
      .then(({ data }) => {
        if (!alive) return;
        if (data.logged_in) ssoDone();
        setState({ loading: false, loggedIn: !!data.logged_in, role: data.role || null, username: data.username || null,
          displayName: data.display_name || null, home: data.home || null, portalUrl: data.portal_url || null,
          ssoStart: data.sso_start || null });
      })
      .catch(() => { if (alive) setState({ loading: false, ...EMPTY }); });
    return () => { alive = false; };
  }, []);

  return state;
}
